import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import TpEvaluatorTpJobPaymentSearchParams from './TpEvaluatorTpJobPaymentSearchParams';
import ThirdPartyJobPaymentsService from '../../../../Services/ThirdParty/ThirdPartyJobPaymentsService';
import TpEvaluatorTpJobPaymentClientInvoiceItem from '../../../../Domain/TpEvaluatorTpJobPaymentClientInvoiceItem';

export default class TpEvaluatorTpJobPaymentSubTab extends React.Component {
  static defaultProps = {
    tpClientInvoiceId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new TpEvaluatorTpJobPaymentSearchParams(),
    };
    this.state.searchItem.TpClientInvoiceId = this.props.tpClientInvoiceId;

    this.startSearch = this.startSearch.bind(this);
    this.serviceFunction = this.serviceFunction.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
  }

  startSearch(searchItem) {
    // "Clear All Filters" hands back a fresh search item without the invoice id. The list re-adds it
    // for its own fetch, but the Excel export sends this item as it is.
    searchItem.TpClientInvoiceId = this.props.tpClientInvoiceId;
    this.setState({ searchItem });
  }

  serviceFunction(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    const tempSearchItem = { ...searchItem };
    tempSearchItem.TpClientInvoiceId = this.props.tpClientInvoiceId;
    return ThirdPartyJobPaymentsService.GetTpEvaluatorTpJobPaymentsForClientInvoice(
      orderById,
      orderDir,
      pageNumber,
      numberOfElements,
      tempSearchItem,
      clearCache
    );
  }

  handleExportExcelButtonClick() {
    ThirdPartyJobPaymentsService.ExportToExcel(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('TPEJPST56')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={TpEvaluatorTpJobPaymentClientInvoiceItem}
          serviceFunction={this.serviceFunction}
          convertDBItemsFunction={ThirdPartyJobPaymentsService.ConvertDBItemsForClientInvoice}
          searchParamsType={TpEvaluatorTpJobPaymentSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          orderBy='TpEvaluatorName'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in various fields...'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportExcelButtonClick}
          excelExportRoleKey='tpclientinvoices_view'
          errorCode='TPEJPST76'
        />
      </div>
    );
  }
}
